module.exports = __webpack_public_path__ + "img/nav-point.de4739a5.svg";